import { mobiClient } from '@/services/axiosConfig'
import { CheckConsentRes, CreateConsentRes, SimRecoverRes, TanConfirmReq, TanConfirmResult, TanCreateReq, TanCreateRes } from './types'

export const tanCreate = async (req: TanCreateReq): Promise<TanCreateRes | undefined> => {
  try {
    const res = await mobiClient.get('/sim/tan', { headers: { ...req } })

    return res.data
  } catch (e: any) {
    return e.response?.data
  }
}
export const tanConfirm = async (req: TanConfirmReq): Promise<TanConfirmResult | undefined> => {
  try {
    const res = await mobiClient.post('/sim/tan', req)
    return res.data
  } catch (e: any) {
    return e.response?.data
  }
}
export const get = async (id: string): Promise<SimRecoverRes | undefined> => {
  try {
    const res = await mobiClient.get('/sim', { headers: { ...{ id } } })
    return res.data
  } catch (e: any) {
    return e.response?.data
  }
}
export const checkConsent = async (phoneNumber: string): Promise<CheckConsentRes | undefined> => {
  try {
    const res = await mobiClient.post('/sim/consent', { phoneNumber })
    return res.data
  } catch (e: any) {
    return e.response?.data
  }
}

export const createConsent = async (sessionId: string): Promise<CreateConsentRes | undefined> => {
  try {
    const res = await mobiClient.get('/sim/consent?sessionId=' + sessionId)
    return res.data
  } catch (e: any) {
    return e.response?.data
  }
}
